var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.692 2.225H.308C.138 2.225 0 2.125 0 2c0-.124.138-.225.308-.225h3.384c.17 0 .308.1.308.225 0 .124-.138.225-.308.225zM20.667 2.225H7.333C7.15 2.225 7 2.125 7 2c0-.124.15-.225.333-.225h13.334c.184 0 .333.1.333.225 0 .124-.15.225-.333.225z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.651 9.225H.35C.156 9.225 0 9.125 0 9c0-.124.156-.225.349-.225H14.65c.193 0 .349.1.349.225 0 .124-.156.225-.349.225zM20.667 9.225h-3.334c-.184 0-.333-.1-.333-.225 0-.124.15-.225.333-.225h3.334c.184 0 .333.1.333.225 0 .124-.15.225-.333.225z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.652 16.225H.348c-.192 0-.348-.1-.348-.225 0-.124.156-.225.348-.225h7.304c.192 0 .348.1.348.225 0 .124-.156.225-.348.225zM20.656 16.225H10.344c-.19 0-.344-.1-.344-.225 0-.124.154-.225.344-.225h10.312c.19 0 .344.1.344.225 0 .124-.154.225-.344.225z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c4a603e7.svg";
export { ForwardRef as ReactComponent };